export default build =>
    build.mutation({
        query(payload) {
            console.log("payload",payload)
            return {
             
               url: '/result/checkCenterMeritListTse', 
                method: 'POST',
                body: payload,
               
            };
        },
       // invalidatesTags: ['allDistricts'],
    })
